/**
 * Moving the student on after a question is behind them.
 *
 * Both solving views (the session page and the independent-mode page) show one
 * exercise at a time, and an exercise is one question — so "next" is always the
 * next slide. There used to be a second target, the next field still on the
 * same slide; nothing has ever put two questions on one slide.
 */

/** Pause before the next exercise replaces the one just finished, so the green
 *  "Teisingai!" is seen before the page changes under it. */
export const SLIDE_ADVANCE_MS = 700;
